import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { configureViewerOnlyHttpProtection } from './utils/viewerOnly';
import { configureApiAuthentication } from './utils/apiAuth';

configureViewerOnlyHttpProtection();
configureApiAuthentication();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
